import { Button, Popover, Row } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";
import { FilterChipsType, FilterChips, FILTER_CONFIG } from "./filterConfig";
import styles from "./Filters.module.scss";

type FilterDropdownItemType = {
  label: string;
  handleOnSelect: () => void;
  isSelected: boolean;
};

const FilterDropdownItem = ({
  label,
  handleOnSelect,
  isSelected,
}: FilterDropdownItemType) => (
  <div onClick={handleOnSelect} className={styles.filterDropdownItem}>
    <span>{label}</span>
    {isSelected && (
      <Row.Item shrink>
        <i className="narmi-icon-check" />
      </Row.Item>
    )}
  </div>
);

// filter chip w. icon that renders filters in dropdown when clicked
const ParentFilterChip = ({
  visibleFilters,
  handleSetActive,
  isActive,
  handleToggleFilter,
  parentSelectableFilters,
}: {
  visibleFilters: FilterChipsType[];
  handleSetActive: (filterName: FilterChips | "") => void;
  isActive: boolean;
  handleToggleFilter: (filterName: FilterChipsType) => void;
  parentSelectableFilters: FilterChipsType[];
}) => {
  const { l10n } = useLocalization();

  const renderFiltersDropdown = () => (
    <div className={styles.filterDropdownContainer}>
      {parentSelectableFilters.map((filterName) => (
        <FilterDropdownItem
          key={filterName}
          isSelected={visibleFilters.includes(filterName)}
          label={l10n.getString(FILTER_CONFIG[filterName].labelKey)}
          handleOnSelect={() => handleToggleFilter(filterName)}
        />
      ))}
    </div>
  );

  const handleToggleChip = () => {
    if (isActive) {
      handleSetActive("");
    } else {
      handleSetActive(FilterChips.PARENT);
    }
  };

  return (
    <>
      <Popover
        onUserEnable={handleToggleChip}
        onUserDismiss={handleToggleChip}
        isOpen={isActive}
        content={renderFiltersDropdown()}
      >
        <Button
          kind="secondary"
          size="xs"
          testId="parent-filter-popover-button"
        >
          <i className="narmi-icon-filter-2 fontSize--m" />
        </Button>
      </Popover>
    </>
  );
};

export default ParentFilterChip;
